import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'


/**
 * hidden: true                   如果设置为true，将不会显示在侧边栏（默认为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单，无论其子路由长度如何
 *                                如果没有设置alwaysShow，则只能有多个孩子下的显示
 *                                它会变成嵌套模式，否则不会显示根菜单
 * redirect: noredirect           如果 `redirect:noredirect` 将不会在面包屑中重定向
 * name:'router-name'             name属性使用了 <keep-alive> (必须设置!!!)
 * meta : {
    title: 'title'               他名字显示在子菜单和面包屑（推荐设置）
    icon: 'svg-name'             该图标显示在边栏中
  }
 **/
export const RouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    children: [{
      path: '/welcome',
      name: 'welcome',
      component: () => import('@/views/welcome/index')
    }]
  },
  {
    path: '',
    component: Layout,
    children: [{
      path: '',
      name: '用户系统',
      meta: {title: '管理系统', icon: 'icon'}
    }]
  },
  /*********用户管理系统***************************/
  {
    path: '/system',
    component: Layout,
    redirect: '/system/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'systemManage',
      component: () => import('@/views/userManageSystem/systemManage'),
      meta: {title: '系统管理'}
    }, {
      path: 'newOrModify',
      name: 'newOrModify',
      component: () => import('@/views/userManageSystem/userList/newOrModify'),
      meta: {title: '新增或修改用户'}
    }, {
      path: 'administrationRole',
      name: 'administrationRole',
      component: () => import('@/views/userManageSystem/userList/administrationRole'),
      meta: {title: '管理角色'}
    }, {
      path: 'roleList',
      name: 'roleList',
      component: () => import('@/views/userManageSystem/userList/roleList'),
      meta: {title: '添加角色列表'}
    }, {
      path: 'roleInfo',
      name: 'roleInfo',
      component: () => import('@/views/userManageSystem/roleAdministration/roleInfo'),
      meta: {title: '角色信息'}
    }, {
      path: 'jurisdictionDetails',
      name: 'jurisdictionDetails',
      component: () => import('@/views/userManageSystem/jurisdictionList/jurisdictionDetails'),
      meta: {title: '权限信息'}
    }]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'userList',
      component: () => import('@/views/userManageSystem/userList'),
      meta: {title: '用户列表'}
    }]
  },
  {
    path: '/material',
    component: Layout,
    redirect: '/material/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'capitalMaterialsList',
      component: () => import('@/views/userManageSystem/capitalMaterialsList'),
      meta: {title: '资方材料列表'}
    }]
  },
  {
    path: '/role',
    component: Layout,
    redirect: '/role/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'roleAdministration',
      component: () => import('@/views/userManageSystem/roleAdministration'),
      meta: {title: '角色列表'}
    }]
  },
  {
    path: '/privilege',
    component: Layout,
    redirect: '/privilege/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'jurisdictionList',
      component: () => import('@/views/userManageSystem/jurisdictionList'),
      meta: {title: '权限列表'}
    }]
  },
  /*********组织管理系统***************************/
  {
    path: '/company',
    component: Layout,
    redirect: '/company/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'companyManage',
      component: () => import('@/views/organizationManage/companyManage'),
      meta: {title: '公司管理'}
    }]
  },
  {
    path: '/department',
    component: Layout,
    redirect: '/department/list',
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'department',
      component: () => import('@/views/organizationManage/department'),
      meta: {title: '部门管理'}
    }]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  scrollBehavior: () => ({y: 0}),
  routes: RouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js